var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import T from '../../Utils/Locale';
import { getGlobalState } from '../../Utils/GlobalState';
import Button from '@frontend-components/components/Button';
import Checkbox from '../../Components/ComponentCheckbox';
const AuthenticationCreateFormConsents = ({ updateUser, errors = {}, acceptedMarketing = false, isLoading = false, goBack, showPartnerConsents = false, partner = null }) => {
    const [hasAcceptedConditions, toggleConditions] = useState(false);
    const [hasAcceptedMarketing, toggleMarketing] = useState(acceptedMarketing);
    const [validationErrors, setValidationErrors] = useState(errors);
    const [partnerConsents, setPartnerConsents] = useState([]);
    const [acceptedPartnerConsents, setAcceptedPartnerConsents] = useState([]);
    useEffect(() => {
        setValidationErrors(errors);
    }, [errors]);
    useEffect(() => {
        if (showPartnerConsents && partner != null) {
            fetchPartnerConsents();
        }
    }, [showPartnerConsents, partner]);
    const handleClickAcceptPartnerConsents = (consentType) => {
        if (acceptedPartnerConsents.includes(consentType)) {
            setAcceptedPartnerConsents(prevState => prevState.filter(consent => consent !== consentType));
        }
        else {
            setAcceptedPartnerConsents(prevState => ([...prevState, consentType]));
        }
    };
    const handleClickValidateConsents = () => {
        const newErrors = {};
        setValidationErrors({});
        if (!hasAcceptedConditions) {
            newErrors.conditions = T('authentication.create.errors.conditions');
        }
        if (partnerConsents.length > 0) {
            partnerConsents.forEach((consent) => {
                if (consent.required && !acceptedPartnerConsents.includes(consent.consentType)) {
                    newErrors[consent.consentType] = consent.error;
                }
            });
        }
        setValidationErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            let data = { marketing: hasAcceptedMarketing ? '1' : '0' };
            if (acceptedPartnerConsents.length > 0) {
                data = Object.assign(Object.assign({}, data), { partnerConsents: acceptedPartnerConsents });
            }
            let consents = [];
            if (hasAcceptedConditions) {
                consents.push('terms');
            }
            if (hasAcceptedMarketing) {
                consents.push('marketing');
            }
            data = Object.assign(Object.assign({}, data), { consents });
            if (acceptedPartnerConsents.length > 0) {
                data = Object.assign(Object.assign({}, consents), { partner_consents: acceptedPartnerConsents });
            }
            updateUser(data);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'form-wrap conditions' }, { children: [_jsx("div", Object.assign({ className: 'input-wrap flex flex-row mt-1 md:mt-5' }, { children: _jsx(Checkbox, { id: 'create-marketing', onChange: (checked) => toggleMarketing(checked), label: T('authentication.create.marketing'), classes: 'tailwind-reset text-darkest-gray font-normal text-sm', inputClassName: 'tailwind-reset' }) })), _jsx("div", Object.assign({ className: 'input-wrap flex flex-row mt-1 md:mt-5' }, { children: _jsx(Checkbox, { id: 'create-conditions', onChange: (checked) => toggleConditions(checked), label: T('authentication.create.conditions'), classes: 'tailwind-reset mr-2 text-darkest-gray font-normal text-sm', inputClassName: 'tailwind-reset', error: validationErrors.conditions }) })), partnerConsents.map((consent) => (_jsx("div", Object.assign({ className: 'input-wrap flex flex-row mt-1 md:mt-5' }, { children: _jsx(Checkbox, { onChange: () => handleClickAcceptPartnerConsents(consent.consentType), label: consent.text, classes: 'tailwind-reset mr-2 text-darkest-gray font-normal text-sm', inputClassName: 'tailwind-reset', error: validationErrors[consent.consentType] }) }), consent.id)))] })), _jsxs("div", Object.assign({ className: 'flex flex-col justify-center items-center mt-11 md:mt-15 mb-12 md:mb-5' }, { children: [_jsx(Button, Object.assign({ id: 'create-submit', onClick: handleClickValidateConsents, size: 'fluid', isLoading: isLoading }, { children: T('authentication.create.button') })), _jsx("div", Object.assign({ className: 'input-wrap' }, { children: _jsx("button", Object.assign({ type: 'button', className: 'tailwind-reset text-dark-teal self-center font-medium text-xs mt-2 ml-2', onClick: goBack }, { children: T('authentication.create.back') })) }))] }))] }));
    function fetchPartnerConsents() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const applicationUrl = getGlobalState('application_url');
            try {
                const { data } = yield axios.get(`${applicationUrl}/api/partner/${partner}`, { withCredentials: true });
                const availableConsents = Array.isArray((_a = data === null || data === void 0 ? void 0 : data.consent) === null || _a === void 0 ? void 0 : _a.consents) ? (_b = data === null || data === void 0 ? void 0 : data.consent) === null || _b === void 0 ? void 0 : _b.consents : Object.values((_d = (_c = data === null || data === void 0 ? void 0 : data.consent) === null || _c === void 0 ? void 0 : _c.consents) !== null && _d !== void 0 ? _d : {});
                const consentsToRender = availableConsents.filter((consent) => consent.visible.includes('CreateUserForm')).map((consent) => {
                    const consentType = consent.options[0].consentType[0];
                    return {
                        text: consent.text,
                        required: consent.required,
                        consentType,
                        error: consent.error
                    };
                });
                setPartnerConsents(consentsToRender);
            }
            catch (_e) {
                console.error('Error');
            }
        });
    }
};
AuthenticationCreateFormConsents.propTypes = {
    updateUser: PropTypes.func.isRequired,
    errors: PropTypes.shape(),
    acceptedMarketing: PropTypes.bool,
    isLoading: PropTypes.bool,
    goBack: PropTypes.func.isRequired,
    partner: PropTypes.string
};
export default AuthenticationCreateFormConsents;
